module.exports = __webpack_public_path__ + "img/internet.8d826f0b.png";